import axios from '../axios';

export const fetchAllReviewsongs = (payload) => axios.post('/songs', payload);
